// Top-level layout. A tenant-membership gate wraps the shell so an
// authenticated Bekaert user with no tenant access never sees the chat UI.

import { AppShell } from "@/components/shell/AppShell";
import { TenantGate } from "@/components/shell/TenantGate";

export function App() {
  return (
    <TenantGate>
      <AppShell />
    </TenantGate>
  );
}
